// extracted by mini-css-extract-plugin
export default {"container":"DG-z","header":"EG-z","details":"FG-z","link":"GG-z"};